
import { defineComponent, ref } from 'vue'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { PortalResetPasswordResponse } from '@/contracts/api/ResponseContracts'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { nuxeoResetPassword } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'ForgottenPasswordConfirm',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        const router = useRouter()
        const route = useRoute()
        const store = useStore()

        const token = route.query.g as string
        // Show the form whenever a token is present; validity (existence,
        // 1-hour expiry, single-use) is enforced server-side by
        // /auth/reset-password on submit, not in the browser.
        const showForm = ref(Boolean(token))

        if(!token)
        {
            store.commit('errors/setNuxeoErrors',
            {
                message: 'Your password reset link is invalid or has already been used. Please request a new one.'
            })
        }

        const fields =
        {
            password:
            {
                name: 'password',
                type: 'Input',
                label: 'Password',
                hint: 'Password must contain at least one lowercase letter, one uppercase letter, one special character, at least one digit and a minimum of 8 characters long.',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    password:
                    {
                        config: true
                    }
                }
            },
            passwordconfirm:
            {
                name: 'passwordconfirm',
                type: 'Input',
                label: 'Confirm password',
                hint: 'Please confirm your password',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    confirm:
                    {
                        config: 'password'
                    }
                }
            }
        }

        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Update password'
            }
        }

        const saveFormData = (formData: FormDataStructure) =>
        {
            nuxeoResetPassword(token, formData.password, function(_response: PortalResetPasswordResponse)
            {
                // Hide the form on success; failures are surfaced by handleError
                // (invalid/expired/used link) with the form left in place.
                showForm.value = false

                store.commit('confirmations/setConfirmationData',
                {
                    title: 'Password updated',
                    body: 'Your password has been updated'
                })
                router.push({ hash: '#confirmation-summary-container' })
            })
        }

        return {
            showForm,
            fields,
            buttons,
            saveFormData
        }
    }
})
